import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { resyncPush } from '@/lib/push'

/**
 * Keeps this browser's push subscription attached to whoever is signed in,
 * and lets a tapped notification move an already-open tab (public/sw.js
 * posts 'evtimia-open' when it cannot navigate the tab itself). Mounted once,
 * in CrmUnreadProvider, which wraps every CRM and portal page.
 */
export function usePushBridge(userId: string | undefined) {
  const navigate = useNavigate()

  useEffect(() => {
    if (userId) void resyncPush()
  }, [userId])

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { type?: string; url?: string } | null
      if (data?.type === 'evtimia-open' && typeof data.url === 'string' && /^\/(?!\/)/.test(data.url)) {
        navigate(data.url)
      } else if (data?.type === 'evtimia-push-resubscribe') {
        void resyncPush()
      }
    }
    navigator.serviceWorker.addEventListener('message', onMessage)
    return () => navigator.serviceWorker.removeEventListener('message', onMessage)
  }, [navigate])
}
